import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { AutosuggestService } from '../autosuggest.service';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';
import { CommonService } from '../services/common.service';

@Component({
  selector: 'app-add-coupon',
  templateUrl: './add-coupon.component.html',
  styleUrls: ['./add-coupon.component.css']
})
export class AddCouponComponent implements OnInit {

  @ViewChild('fileInput') fileInput;
  myOptions: INgxMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    // This will disable dates starting from tomorrow
  };
  model: any = {};
  user: any = {};
  results: any = {};
  currentUser: any = {};
  currentOrg: any;
  sessionData: any = {};
  searching = false;
  searchFailed = false;
  hideSearchingWhenUnsubscribed = new Observable(() => () => this.searching = false);
  certList: any = [];
  certificate: any = {
    cert_details: []
  };
  cert: any = {};
  contId: number;
  mask: any[] = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  tinmask: any[] = [/[0-9]/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  certmask: any[] = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  userType: number;
  showLoader: boolean;
  wbe_goal: number;
  mbe_goal: number;
  savecertList: any;
  fieldName: string;
  fileList: FileList;
  certId: any;
  fileU: boolean;
  formedata: FormData;
  onlyview: boolean = false;
  headerLabel: string;
  getservicecategories: any;
  getservicelists: any = [];
  list: any;
  totAmt: number = 0;
  getRetailProducts: any[];
  buyingProducts: any = [];
  search: any = [];
  type: any;
  checkall: any;
  constructor(
    private router: Router,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private _arout: ActivatedRoute,
    private _flashMessagesService: FlashMessagesService,
    private _common: CommonService

  ) { }
  ngOnInit(): void {
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    this.checkall = { checked: false };
    this.loginservice.getservicecategory('', '4', this.currentUser).subscribe(data => {
      this.getservicecategories = data['comp_details'];
    },
      error => {
        alert('Network Error getservicecategory API');
      });
    // this.loginservice.getserviceList('').subscribe(data => {
    //   this.getservicelists = data['comp_details'];
    // });
    this.getRetailProduct();

    this.model = {
      service_category_id: '0',
      distype: '',
      combine_offer: 'no',
      totAmt: 0,
      cus_limit: 5,
      min_amt: 0,
      exc_coupon: '',
      takeall: 'no',
      partnership_coupon: '',
    };

    this._arout.params.subscribe(p => {
      if (p.view_id) {
        this.onlyview = true;
      }

      if (p.type) {
        this.type = p.type;
      } else {
        this.type = '4,6'
      }

      if (p.service_offered_id) {
        this.headerLabel = 'Edit';
        this.loginservice.getserviceListWithcategory('', this.currentUser).subscribe(data => {
          this.getservicelists = data['comp_details'];
          setTimeout(() => { this.getserviceoffered(p.service_offered_id); }, 300);
        },
          error => {
            alert('Network Error getserviceListWithcategory API');
          });
      } else {
        this.loginservice.getserviceListWithcategory('', this.currentUser).subscribe(data => {
          this.getservicelists = data['comp_details'];
        },
          error => {
            alert('Network Error getserviceListWithcategory API');
          });
        this.headerLabel = 'New';
        // this.getserviceoffered('');
      }
    },
      error => {
        alert('Network Error get params API');
      });


  }

  clear() {
    this.model = {
      ...this.model,
      service_category_id: '0',
      distype: '',
      combine_offer: 'no',
      totAmt: 0,
      disAmt: 0,

    };
  }
  assign_checkbox(data) {
    data.forEach((obj) => {
      if (obj.type === 6 || obj.type === '6') {
        this.getRetailProducts.forEach((items) => {
          items.service.forEach((item) => {
            item.list.forEach((i) => {
              // return false
              if (i['id'] === obj['inventory_manager_id']) {
                i.checked = true;
                this.buyingProducts.push(i);
              }
            });
          });
        });
      } else {
        this.getservicelists.forEach((items) => {
          items.service_list.forEach((item) => {
            if (item['service_list_id'] === obj['service_list_id'] && item['service_category_id'] === obj['ori_id']) {
              item.checked = true;
            }
          });
        });
      }
    });
  }

  calculate(allow) {
    if (allow == 'clear') {
      this.model['disAmt'] = 0;
      this.getRetailProducts.forEach(element => {
        this.uncheckAll(element)
        // this.chekspack(element);
      });
    }

    if (this.model['totAmt'] > 0 && this.model['distype'] != '' && this.model['disAmt'] > '0') {
      if (this.model['distype'] === 'amount') {
        this.model['final_price'] = this.model['totAmt'] - this.model['disAmt'];
      } else if (this.model['distype'] === 'percentage') {
        this.model['final_price'] = this.model['totAmt'] - (this.model['totAmt'] / 100) * this.model['disAmt'];
      }
    } else {
      this.model['final_price'] = 0;
    }

    if (allow == '') {
      this.getRetailProducts.forEach(element => {
        this.uncheckAll(element)
        // this.chekspack(element);
      });
    }
  }

  uncheckAll(covenant) {
    covenant.checked = false;
    covenant.service.forEach(element => {
      element.list.forEach((element, index) => {
        element.checked = false;
      });
      element.list.forEach((element, index) => {
        element.checked = false;
      });
    });
  }

  chekspackAll(event: Event) {
    this.getservicelists.forEach(element => {
      if ((event.target as HTMLInputElement).checked) {
        this.chekspack(element, false);
      } else {
        this.chekspack(element, true);
      }
      // return false;
    });
  }

  chekspack(items, trufal) {
    if (trufal == true) {
      items.checked = true;
    } else {
      items.checked = false;
    }
    if (items.checked) {
      const NormalCategory = items.service_list.filter(item => !item.checked);
      if (NormalCategory.length > 0) {
        items.service_list.forEach((element, index) => {
          if (!element.checked) {
            this.getprice(element, '+')
          }
          element.checked = false;
        });
      }
      items.service_list.forEach((element, index) => {
        this.getprice(element, '-')
        element.checked = false;
      });
    } else {
      const NormalCategory = items.service_list.filter(item => item.checked);
      if (NormalCategory.length > 0) {
        items.service_list.forEach((element, index) => {
          if (element.checked) {
            this.getprice(element, '-')
          }
          element.checked = false;
        });
      }
      items.service_list.forEach((element, index) => {
        element.checked = true;
        this.getprice(element, '+')
      });
    }
    if (trufal == true) {
      items.checked = false;
    } else {
      items.checked = true;
    }
  }

  async chekspackProAll(event: Event) {
    for (const element of this.getRetailProducts) {
      const shouldContinue = await this.chekspackPro(element, event);
      if (!shouldContinue) {
        break;  // Stop the loop if chekspackPro returns false
      }
    }
  }

  async chekspackPro(covenant, event: Event): Promise<boolean> {
    if ((event.target as HTMLInputElement).checked) {
      if (this.model.distype !== '') {
        if (this.model.disAmt > 0) {
          for (const elements of covenant.service) {
            for (const item of elements.list) {
              try {
                const data = await this.loginservice.getRetailDis(item.id, this.currentUser).toPromise();
                if (this.model.distype === 'percentage') {
                  if (parseInt(this.model['disAmt']) > parseInt(data['data']['productDisForCus']) && this.model.partnership_coupon !== '3') {
                    covenant.checked = false;
                    setTimeout(() => { this.checkall.checked = false; }, 1000);
                    item.checked = false;
                    alert('Given Percentage is Higher');
                    return false;  // Return false to stop the loop
                  }
                } else {
                  if (parseInt(this.model['disAmt']) > ((parseInt(data['data']['amt_per']) * parseInt(data['data']['productDisForCus'])) / 100) && this.model.partnership_coupon !== '3') {
                    covenant.checked = false;
                    setTimeout(() => { this.checkall.checked = false; }, 1000);
                    item.checked = false;
                    alert('Given Amount is Higher');
                    return false;  // Return false to stop the loop
                  }
                }
              } catch (error) {
                console.error("Error fetching retail discount:", error);
                alert('Error fetching discount data.');
                return false;  // Stop the loop on error
              }
            }
          }

          // If no early return, proceed with price updates
          covenant.service.forEach(element => {
            const normalCategory = element.list.filter(item => item.checked);
            if (normalCategory.length > 0) {
              element.list.forEach((element) => {
                if (element.checked) {
                  this.getprice1(element, '-');
                }
                element.checked = false;
              });
            }
            element.list.forEach((element) => {
              element.checked = true;
              this.getprice1(element, '+');
            });
          });

        } else {
          covenant.checked = false;
          setTimeout(() => { this.checkall.checked = false; }, 1000);
          alert('Please Choose Discount Value');
          return false;  // Return false to stop the loop
        }
      } else {
        covenant.checked = false;
        setTimeout(() => { this.checkall.checked = false; }, 1000);
        alert('Please Choose Discount Type');
        return false;  // Return false to stop the loop
      }
    } else {
      covenant.service.forEach(element => {
        const normalCategory = element.list.filter(item => !item.checked);
        if (normalCategory.length > 0) {
          element.list.forEach((element) => {
            if (!element.checked) {
              this.getprice1(element, '+');
            }
            element.checked = false;
          });
        }
        element.list.forEach((element) => {
          this.getprice1(element, '-');
          element.checked = false;
        });
      });
    }

    return true;  // Return true to continue the loop
  }



  getserviceoffered(service_offered_id) {
    this.loginservice.getserviceofferedsAddEdit(service_offered_id, this.type, this.currentUser)
      .subscribe(
        data => {
          if (data['status'] == 'success') {
            if (service_offered_id) {
              // this.model['service_offered_id'] = data['0']['service_offered_id'];
              this.model['service_category_id'] = data['data']['0']['service_category_id'];
              this.model['coupon'] = data['data']['0']['service_category'];
              this.model['coupon_code'] = data['data']['0']['coupon_code'];
              this.model['start_date'] = data['data']['0']['start_date'];
              this.model['end_date'] = data['data']['0']['end_date'];
              this.model['combine_offer'] = data['data']['0']['combine_offer'];
              this.model['min_amt'] = data['data']['0']['min_amt'];
              this.model['service_product'] = data['data']['0']['service_product'];
              this.model['takeall'] = data['data']['0']['takeall'];
              this.model['exc_coupon'] = data['data']['0']['exc_coupon'];
              this.model['partnership_coupon'] = data['data']['0']['partnership_coupon'];
              this.model['cus_limit'] = data['data']['0']['cus_limit'];
              this.totAmt = this.model['totAmt'] = parseInt(data['data']['0']['totAmt']);
              this.model['distype'] = data['data']['0']['distype'];
              this.model['disAmt'] = data['data']['0']['disAmt'];
              this.assign_checkbox(data['data']);
            }
            this.showLoader = false;
          } else {
            this.model = [];
            // this._flashMessagesService.show('No Vendors!', { cssClass: 'alert-danger' });
            // this.router.navigate(['addlowertier']);
            this.showLoader = false;
          }

        },
        error => {
          alert('Network Error getserviceofferedsAddEdit API');
          this.showLoader = false;
        });
  }


  setCat(n) {
    if (n > 0) {
      this.model.service_category_id = n;
    } else {
      this.model.service_category_id = '';
    }
  }


  savecoupon() {
    // const checkedItems = this.getservicelists.filter(item => item.checked);
    // const checkedItems = this.getservicelists.filter(item => item.checked);
    let checkedItems = []
    if (this.model['service_product'] == '1') {
      checkedItems = this.getservicelists.flatMap(item =>
        item.service_list.filter(items => items.checked)
      );
    } else {
      checkedItems = this.buyingProducts.filter(items => items.checked)
    }


    if ((this.model['distype'] === '' && (this.model['disAmt'] > '0' && this.model['disAmt'] !== '')) || (this.model['distype'] !== '' && (this.model['disAmt'] <= '0' || this.model['disAmt'] === ''))) {
      this._flashMessagesService.show('Please Fill Discount Type & Amount', { cssClass: 'alert-danger' });
      return false;
    }


    if (checkedItems.length > 0) {
      let uniqueCheckedItems;
      this.showLoader = true;
      if (this.model['service_product'] == '1') {
        this.model['type'] = 4;
        uniqueCheckedItems = checkedItems;
      } else {
        this.model['type'] = 6;
        uniqueCheckedItems = checkedItems.filter((item, index, self) => {
          return index === self.findIndex((t) => (
            t.inventory_manager_id === item.inventory_manager_id && t.id === item.id
          ));
        });
      }

      // this.model['start_date'] = this.loginservice.Objecttodate(this.model['start_date'].date);
      this.loginservice.savecoupon(this.model, uniqueCheckedItems, this.currentUser)
        .subscribe(
          data => {
            if (data['status'] === 'success') {
              this._flashMessagesService.show('Updated Successfully', { cssClass: 'alert-success' });
              this.showLoader = false;
              this.router.navigate(['/coupon']);
            } else {
              this._flashMessagesService.show(data['message'], { cssClass: 'alert-danger' });
              this.showLoader = false;
            }
          },
          error => {
            alert('Network Error savecoupon API');
          });
    }
  }

  checkPrice1(item) {
    // this.totAmt = 0;
    // this.model['totAmt'] = 0;
    // this.model['distype'] = '';
    // this.model['disAmt'] = 0;
    // this.model['final_price'] = 0;
    // if (item.checked) {
    //   this.getprice1(item, '-')
    // } else {
    //   this.getprice1(item, '+')
    // }

    if (item.checked) {
      this.getprice1(item, '-')
    } else {
      if (this.model.distype != '') {
        if (this.model.disAmt > 0) {
          if (this.model.distype == 'percentage') {
            this.loginservice.getRetailDis(item.id, this.currentUser)
              .subscribe(
                data => {
                  if (parseInt(this.model['disAmt']) > parseInt(data['data']['productDisForCus']) && this.model.partnership_coupon !== '3') {
                    alert('Given Percentage is Higher')
                    setTimeout(() => { item.checked = false; }, 300);
                  } else {
                    this.getprice1(item, '+')
                  }
                },
                error => {
                  alert('Network Error getRetailDis API');
                });
          } else {
            this.loginservice.getRetailDis(item.id, this.currentUser)
              .subscribe(
                data => {
                  if (parseInt(this.model['disAmt']) > ((parseInt(data['data']['amt_per']) * parseInt(data['data']['productDisForCus'])) / 100) && this.model.partnership_coupon !== '3') {
                    alert('Given Amount is Higher')
                    setTimeout(() => { item.checked = false; }, 300);
                  } else {
                    this.getprice1(item, '+')
                  }
                },
                error => {
                  alert('Network Error getRetailDis API');
                });
          }
        } else {
          alert('Please Choose Discount Value')
          setTimeout(() => { item.checked = false; }, 300);
        }
      } else {
        alert('Please Choose Discount Type')
        setTimeout(() => { item.checked = false; }, 300);
      }
    }
  }

  checkPrice(item) {
    // this.totAmt = 0;
    // this.model['totAmt'] = 0;
    // this.model['distype'] = '';
    // this.model['disAmt'] = 0;
    // this.model['final_price'] = 0;
    if (item.checked) {
      this.getprice(item, '-')
    } else {
      this.getprice(item, '+')
    }
  }

  getprice1(item: any, operator: string) {
    this.loginservice.checkPrice1(item, this.currentUser)
      .subscribe(
        (data: any) => {
          let value: any = data;
          if (operator === '+') {
            // Assuming data is a string representing a numeric value
            this.totAmt += parseInt(value);
          } else {
            // Handle other cases if needed
            this.totAmt -= parseInt(value);
          }
          this.model['totAmt'] = this.totAmt;
          this.calculate('allow');
          if (item.checked) {
            this.buyingProducts.push(item);
          } else {
            if (this.buyingProducts.length > 0) {
              const existingIndex = this.buyingProducts.findIndex(elem => elem.id === item.id);
              if (existingIndex !== -1) {
                this.buyingProducts.splice(existingIndex, 1);
              }
            }
          }
        },
        (error: any) => {
          alert('Network Error checkPrice1 API');
          // Handle error if necessary
        }
      );
  }


  getprice(item: any, operator: string) {
    this.loginservice.checkPrice(item, this.currentUser)
      .subscribe(
        (data: any) => {
          let value: any = data;
          if (operator === '+') {
            // Assuming data is a string representing a numeric value
            this.totAmt += parseInt(value);
          } else {
            // Handle other cases if needed
            this.totAmt -= parseInt(value);
          }
          this.model['totAmt'] = this.totAmt;
          this.calculate('allow');
        },
        (error: any) => {
          alert('Network Error checkPrice API');
          // Handle error if necessary
        }
      );
  }


  onDateChanged(type, event: IMyDateModel): void {
    // date selected
    if (type === 'month') {
      this.model['getmonth'] = event;
    } else {
      this.model['getyear'] = event;
    }
  }


  getRetailProduct() {
    this.loginservice.getRetailProduct(this.search, this.currentUser)
      .subscribe(
        data => {
          if (data['status'] == 'success') {
            this.getRetailProducts = data['data'];
            this.getRetailProducts.forEach((covenant: any) => {
              if (covenant.service) {
                covenant.service.forEach((item: any) => {
                  if (item.list) {
                    item.list.forEach((product: any) => {
                      product.checked = false; // Initialize 'checked' property
                      if (this.buyingProducts.length > 0) {
                        this.buyingProducts.forEach(element => {
                          if (element.id == product.id) {
                            product.checked = true;
                          }
                        });
                      }

                    });
                  }
                });
              }
            });
          } else {
            this.getRetailProducts = [];
          }
        }
        ,
        error => {
          alert('Network Error getRetailProduct API');
        });
  }

}



// WEBPACK FOOTER //
// ./src/app/add-coupon/add-coupon.component.ts